import { render, staticRenderFns } from "./ListServersSection.vue?vue&type=template&id=b50600a0&"
import script from "./ListServersSection.vue?vue&type=script&lang=js&"
export * from "./ListServersSection.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports